var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"cta-link md:mt-6 mt-4",attrs:{"href":_vm.href}},[_vm._t("default"),_vm._v(" "),_c('ui-icon',{staticClass:"ml-2 mt-0.5 text-lg",attrs:{"icon":"arrow"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }